import { Component } from '@angular/core';
import { CaptureHistoryItemTypeBaseComponent } from '../capture-history-item-type-base/capture-history-item-type-base.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';


@Component({
    selector: 'app-capture-history-item-type-created',
    templateUrl: './capture-history-item-type-created.component.html',
    imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent]
})
export class CaptureHistoryItemTypeCreatedComponent extends CaptureHistoryItemTypeBaseComponent {
  get title() {
    return 'Capture Created';
  }

  get description() {
    return 'New capture created';
  }

  get matchConfidence() {
    return this.captureHistoryItem.data && this.captureHistoryItem.data.matchConfidence;
  }

  get claimType() {
    return this.captureHistoryItem.data && this.captureHistoryItem.data.claimType;
  }
}
